import axios from 'axios';
import _ from 'lodash';

function getCountyProviders(countyFips) {
  const fips = _.padStart(countyFips, 5, '0');
  const url = `${process.env.PUBLIC_URL}/data/providers/fips_${fips}.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getCountyData() {
  const url = `${process.env.PUBLIC_URL}/data/counties.min.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getStateData() {
  const url = `${process.env.PUBLIC_URL}/data/states.min.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getDemographicsData() {
  const url = `${process.env.PUBLIC_URL}/data/od.demographics.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

export default {
  getCountyProviders,
  getCountyData,
  getStateData,
  getDemographicsData
}


// WEBPACK FOOTER //
// ./src/services/data-service.js